import { useContext } from 'react'
import PMSSchedulesCalendar from 'app/components/scheduling/PMSSchedulesCalendar'
import { PAGE_GUTTER, PageGutterContext } from 'app/components/layout/PageScroll'
import { cn } from 'app/lib/utils'
import type { UsePmsSchedulesLocationReturn } from './usePmsSchedulesLocation'

export type PmsSchedulesLocationComponentProps = UsePmsSchedulesLocationReturn

export function PmsSchedulesLocationComponent(props: PmsSchedulesLocationComponentProps) {
  const gutter = useContext(PageGutterContext)
  return (
    // Outside the settings well, `main` already carries the page gutter and top padding; inside
    // the well `main`'s gutter is stripped, so this wrapper takes over both only in that context.
    <div className={cn(`flex h-full flex-col`, gutter === `inset` && cn(PAGE_GUTTER.inset, `pt-8`))}>
      <PMSSchedulesCalendar {...props} showPageHeader />
    </div>
  )
}
